import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Drawer,
  // MenuItem,
  // InputLabel,
  IconButton,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import moment from 'moment';
import { ja } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ListSupplyGochiTable from '../organisms/ListSupplyGochiTable';
import SearchButton from '../../components/atoms/SearchButton';
import { getAccounts } from '../../actions/Accounts';
// import {
//   updateTicketsStatus,
//   UPDATE_TICKETS_STATUS_SUCCESS
// } from '../../actions/Tickets';
import {
  getTicketsGochi,
  downloadTicketsGroup,
  GET_TICKETS_GOCHI_SUCCESS,
  DOWNLOAD_TICKETS_GROUP_SUCCESS
} from '../../actions/Budgets';

// import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import { getSystems } from '../../actions/Systems';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  inputLabel: {
    fontSize: 12,
    width: '100%'
  },
  boxMargin: {
    marginTop: 16,
    marginBottom: 8,
    width: '300px',
    minWidth: 300
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getTicketsGochi,
          // updateTicketsStatus,
          getSystems,
          downloadTicketsGroup
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('groupId', 'setGroupId', null),
  withState('groupName', 'setGroupName', null),
  withState('menuId', 'setMenuId', null),
  withState('menuName', 'setMenuName', null),
  withState('gochiCreatedAt', 'setGochiCreatedAt', null),
  // withState('gochiCreatedAt', 'setGochiCreatedAt', () => {
  //   moment.tz.setDefault('Asia/Tokyo');
  //   return moment()
  //     .date(1)
  //     .format('YYYY-MM-DD');
  // }),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openConfirmDialog', 'setOpenConfirmDialog', false),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('downloadParams', 'setDownloadParams', {}),
  withState('defaultMonth', 'setDefaultMonth', () => {
    return new Date();
  }),
  withState('checked', 'setChecked', () => {
    return new Set();
  }),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    csvDownloadAction: props => async () => {
      props.updateLoading(true);
      props.updateOpenProgress(true);
      const response = await props.actions
        .downloadTicketsGroup(props.downloadParams)
        .then(data => props.checkSession(data));
      if (response.type === DOWNLOAD_TICKETS_GROUP_SUCCESS) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        props.updateOpenProgress(false);
        props.setResultMessage('');
        props.updateLoading(false);
        const blob = response.payload;
        const fileName = `${timeStamp}_ticket_group_info.csv`;

        if (window.navigator.msSaveOrOpenBlob) {
          // for IE,Edge
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          // for chrome, firefox
          const url = URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          );
          const linkEl = document.createElement('a');
          linkEl.href = url;
          linkEl.setAttribute('download', fileName);
          document.body.appendChild(linkEl);
          linkEl.click();

          linkEl.parentNode.removeChild(linkEl);
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 1000);
        }
      } else {
        props.setResultMessage('データエクスポートに失敗しました。');
        props.updateLoading(false);
      }
    }
  }),
  withHandlers({
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);
      let month = '';
      if (props.defaultMonth) {
        month =
          props.defaultMonth.getMonth() < 9
            ? `0${props.defaultMonth.getMonth() + 1}`
            : `${props.defaultMonth.getMonth() + 1}`;
      }
      const searchKey = {
        groupId: props.groupId,
        groupName: props.groupName,
        menuId: props.menuId,
        menuName: props.menuName,
        year: props.defaultMonth ? props.defaultMonth.getFullYear() : '',
        month: props.defaultMonth ? `${month}` : '',
        gochiCreatedAt: props.gochiCreatedAt,
        page,
        limit: limitNum
      };

      props.setDownloadParams(searchKey);

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getTicketsGochi(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_TICKETS_GOCHI_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setErrorMessage('エラーが発生しました！');
          props.updateLoading(false);
          props.updateOpenProgress(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    openDrawer,
    updateOpenDrawer,
    account,
    openTable,
    updateOpenTable,
    openProgress,
    updateOpenProgress,
    page,
    handleChangePage,
    loading,
    updateLoading,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setResultMessage,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    gochiCreatedAt,
    setGochiCreatedAt,
    selectedTicketIds,
    checked,
    setChecked,
    setDefaultMonth,
    defaultMonth,
    errorMessage,
    setErrorMessage,
    csvDownloadAction
  }) => {
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const handleChangeMonth = e => {
      if (e !== '') {
        setDefaultMonth(e);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループごち発行一覧
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={ja}
                libInstance={moment}
              >
                <div className={classes.boxMargin}>
                  {/* <InputLabel className={classes.inputLabel}>
                    予算対象月
                  </InputLabel> */}
                  <DatePicker
                    variant="inline"
                    openTo="year"
                    format="y/M"
                    label="予算対象月"
                    views={['year', 'month']}
                    value={defaultMonth}
                    onChange={handleChangeMonth}
                  />
                  <IconButton
                    style={{ marginTop: '18px' }}
                    edge="end"
                    size="small"
                    disabled={!defaultMonth}
                    onClick={() => handleChangeMonth(null)}
                  >
                    <ClearIcon />
                  </IconButton>
                </div>
                {/* </Grid> */}
              </MuiPickersUtilsProvider>
              <TextField
                label="グループID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupId}
                onChange={e => {
                  setGroupId(e.target.value);
                }}
              />
              <TextField
                label="グループ名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
              <TextField
                label="メニューID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuId}
                onChange={e => {
                  setMenuId(e.target.value);
                }}
              />
              <TextField
                label="メニュー名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuName}
                onChange={e => {
                  setMenuName(e.target.value);
                }}
              />
              <TextField
                label="発行日"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={gochiCreatedAt}
                onChange={e => {
                  setGochiCreatedAt(e.target.value);
                }}
              />
            </div>
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.buttonGroupRight}>
              <CsvDownloadButton onClickAction={csvDownloadAction} />
            </div>
          </div>
          {openTable && (
            <ListSupplyGochiTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
              selectedTicketIds={selectedTicketIds}
              checked={checked}
              setChecked={setChecked}
            />
          )}
        </Paper>
        {/* <ConfirmDialog
          openConfirm={openConfirmDialog}
          updateOpenConfirm={setOpenConfirmDialog}
          message="この社食チケットを未使用に戻しますか。"
          okAction={() => changeTicketStatus(selectedTicketIds)}
        /> */}
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
